export const CONTACT_ADDRESS_SUCCESS = 'CONTACT_ADDRESS_SUCCESS';

export const UPDATE_ORDER_ADDRESS_SUCCESS = 'UPDATE_ORDER_ADDRESS_SUCCESS';

export const UPDATE_ORDER_OWNER_SUCCESS = 'UPDATE_ORDER_OWNER_SUCCESS';
